export const CANCELLATION_CONSTANTS = {
  MINIMUM_HOURS: 12,
  MILLISECONDS_PER_HOUR: 1000 * 60 * 60,
  BRAZIL_COUNTRY_CODE: '55',
  WHATSAPP_BASE_URL: 'https://wa.me/',
  LIMIT_REQUEST_FORM_URL: 'https://tally.so/r/3lNVpV',
}

export const MODAL_TEXTS = {
  ERROR_TITLE: 'Desculpe, não é possível cancelar com menos de 12 horas do horário da consulta.',
  CONFIRMATION_TITLE: 'Cancelar consulta',
  APPOINTMENT_TITLE: 'Cancelar consulta',
  SUCCESS_TITLE: 'Consulta cancelada',
  BUTTON_UNDERSTAND: 'ENTENDI',
  BUTTON_CONTINUE: 'CONTINUAR',
  BUTTON_CONFIRM: 'CONFIRMAR CANCELAMENTO',
  BUTTON_CONFIRMING: 'CONFIRMANDO...'
}
